import {
    createImmutableReducer,
} from '@shared/common';
import * as actions from '../actions';

export default createImmutableReducer(
    {
        inProgress: false,
        progress: [],
    },
    {
        [actions.upload.start]: (state) => {
            state.set('progress', 0).set('inProgress', true);
            state.remove('error');
        },
        [actions.upload.failure]: (state, {payload: {error}}) => {
            state.set('inProgress', false).set('progress', 0);
            state.set('error', error);
        },
        [actions.upload.success]: (state) => state.set('inProgress', false).set('progress', 0),
        [actions.upload.progress]: (state, {payload: {progress}}) => state.set('progress', progress),
        [actions.upload.resetError]: (state) => state.remove('error'),
    },
);

